import { render } from "./TextArgument.vue?vue&type=template&id=cecb781c"
import script from "./TextArgument.vue?vue&type=script&lang=js"
export * from "./TextArgument.vue?vue&type=script&lang=js"
script.render = render

export default script